import { __ } from '@wordpress/i18n';
import './ComponentPanel.css';
import DraggableComponent from './DraggableComponent';

const ComponentPanel = () => {
  const components = [
    { id: 'text', type: 'text', icon: 'font', label: __('Text Input', 'havenlytics') },
    { id: 'textarea', type: 'textarea', icon: 'align-left', label: __('Text Area', 'havenlytics') },
    { id: 'number', type: 'number', icon: 'hashtag', label: __('Number', 'havenlytics') },
    { id: 'checkbox', type: 'checkbox', icon: 'check-square', label: __('Checkbox', 'havenlytics') },
    { id: 'image', type: 'image', icon: 'image', label: __('Image Upload', 'havenlytics') },
    { id: 'gallery', type: 'gallery', icon: 'images', label: __('Gallery (2 Fields)', 'havenlytics') },
    { id: 'video', type: 'video', icon: 'video', label: __('Video (3 Fields)', 'havenlytics') },
    { id: 'map', type: 'map', icon: 'map-marker-alt', label: __('Map Location (4 Fields)', 'havenlytics') },
    { id: 'property_docs', type: 'property_docs', icon: 'file-pdf', label: __('Property Documents', 'havenlytics') }
  ];

  return (
    <div className="hvnly--builder--int_api__property_builder_components">
      <h3>{__('Available Field Types', 'havenlytics')}</h3>
      <p className="hvnly--builder--int_api__component_panel_subtitle">
        {__('Drag and drop to add fields', 'havenlytics')}
      </p>
      
      <div className="hvnly--builder--int_api__component_panel_section">
        <h4 className="hvnly--builder--int_api__component_panel_section_title">
          <i className="fas fa-pencil-alt"></i> {__('Basic Fields', 'havenlytics')}
        </h4>
        <div className="hvnly--builder--int_api__component_panel_grid">
          {components.slice(0, 5).map(component => (
            <DraggableComponent
              key={component.id}
              id={component.id}
              type={component.type}
              icon={component.icon}
              label={component.label}
            />
          ))}
        </div>
      </div>

      <div className="hvnly--builder--int_api__component_panel_section">
        <h4 className="hvnly--builder--int_api__component_panel_section_title">
          <i className="fas fa-layer-group"></i> {__('Group Fields', 'havenlytics')}
        </h4>
        <div className="hvnly--builder--int_api__component_panel_grid">
          {components.slice(5).map(component => (
            <DraggableComponent
              key={component.id}
              id={component.id}
              type={component.type}
              icon={component.icon}
              label={component.label}
            />
          ))}
        </div>
      </div>

      <div className="hvnly--builder--int_api__component_panel_footer">
        <i className="fas fa-info-circle"></i>
        <span>{__('Group fields create multiple related fields at once', 'havenlytics')}</span>
      </div>
    </div>
  );
};

export default ComponentPanel;